import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import DailyCounts from '../DailyCounts';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const DailyCountsTwoPack = (props) => {
  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext).template.dailyCounts;
  const { cases, deaths } = props.counts;

  const casesContent = {
    title: content.cases,
    variableName: content.variableNameCases,
    tooltipSuffix: content.tooltipSuffixCases,
    dailyLabel: content.CasesDailyLabel,
    avgLabel: content.AvgLabel,
    popTooltip: content.PopTooltipCases,
    noData: content.NoDataCases,
  };

  const deathsContent = {
    title: content.deaths,
    variableName: content.variableNameDeaths,
    tooltipSuffix: content.tooltipSuffixDeaths,
    dailyLabel: content.DeathsDailyLabel,
    avgLabel: content.AvgLabel,
    popTooltip: content.PopTooltipDeaths,
    noData: content.NoDataDeaths,
  };

  return (
    <div className={classnames(component)}>
      <div className='section-spacer-internal' />
      <div>
        <h4>{content.title}</h4>
        <DailyCounts
          content={casesContent}
          locale={locale}
          counts={cases}
          showLabels
        />
        <DailyCounts
          content={deathsContent}
          locale={locale}
          counts={deaths}
        />
      </div>
    </div>
  );
};

export default DailyCountsTwoPack;
